import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { useEventCallback } from '@cian/react-utils';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardSectionNew } from 'shared/components/CardSectionNew';
import { SuburbanBuildersProjects } from 'shared/components/SuburbanBuildersProjects';

import { trackAllProjectsClick, trackProjectClick, trackSuggestShow } from './tracking';
import { selectSuburbanBuildersProjects } from '../../selectors/suburbanBuildersProjects';

export const SuburbanBuildersProjectsContainer = () => {
  const suburbanBuildersProjects = useSelector(selectSuburbanBuildersProjects);

  const handleProjectsShow = React.useCallback(() => {
    const products = suburbanBuildersProjects.map(({ projectId }, index) => ({
      id: projectId,
      offerType: 'CSP' as const,
      position: index + 1,
    }));

    trackSuggestShow(products);
  }, [suburbanBuildersProjects]);

  const handleProjectClick = useEventCallback((id: number, position: number) => trackProjectClick(id, position));

  if (!suburbanBuildersProjects.length) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={handleProjectsShow} percentVisible={0.5} triggerOnce callbackDelay={1000}>
      <CardSectionNew title="Постройте дом на этом участке" subtitle="Проекты проверенных строительных компаний">
        <SuburbanBuildersProjects
          items={suburbanBuildersProjects}
          link="/country-builders-projects/?utm_medium=card"
          onProjectClick={handleProjectClick}
          onAllProjectsButtonClick={trackAllProjectsClick}
        />
      </CardSectionNew>
    </ActionAfterViewObserver>
  );
};
